<template>
  <div class="general-modal" v-if="showModal">
    <div class="modal-header">
      <div class="container">
        <h2 v-if="content">{{content.name}}</h2>
        <button @click="closeModal"><i class="material-icons">close</i></button>
      </div>
    </div>

    <ModalVideo v-if="modalType == 'video'" :key="content.id" />
    <ModalImage v-if="modalType == 'image'" />
    <ModalPdf v-if="modalType == 'pdf'" />
    <ModalDescription v-if="modalType == 'description'" :key="content.id" />

    <ModalPlaylist v-if="playlistItems && playlistItems.length > 1" @set="openModal" />
    <div v-else class="spacer"></div>
    
    <div class="overlay" @click="closeModal"></div>
  </div>
</template>

<script>
import ModalPlaylist from "@/components/ModalPlaylist.vue";
import ModalVideo from "@/components/ModalVideo.vue";
import ModalImage from "@/components/ModalImage.vue";
import ModalPdf from "@/components/ModalPdf.vue";
import ModalDescription from "@/components/ModalDescription.vue";
import { modalMixin } from '@/mixins/modalMixin.js'
export default {
  name: "GeneralModal",
  mixins: [modalMixin],
  components: {
    ModalPlaylist,
    ModalVideo,
    ModalImage,
    ModalPdf,
    ModalDescription
  },
  data () {
    return {
      showPlaylist: false,
      player: null
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('modalModule/closeModal')
    },
    getInjectData (id) {
      return this.$store.getters["scenarioModule/getInject"](id);
    },
    openModal (id) {
      this.$store.dispatch('modalModule/setActive', this.getInjectData(id))
    }
  },
  computed: {
    modalType () {
      return this.$store.state.modalModule.type
    }
  }
};
</script>

<style lang="scss" scoped>
.general-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding: 0 0 25px;

  @media all and (min-width: 768px) {
    padding: 0 25px 25px;
  }
}
.overlay {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background-color: rgba(0, 0, 0, 0.84);
  background-color: #1a1a9beb;
}
.modal-header {
  // position: fixed;
  z-index: 600;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: #fff;
  margin-bottom: auto;

  .container {
    max-width: 1024px;
    min-height: 48px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      color: var(--primary);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 21px;
      padding: 0 25px;

      @media all and (min-width: 980px) {
        font-size: 22px;
      }
    }
  }
}
.modal {
  position: relative;
  z-index: 600;
  background-color: #fff;
  max-width: 1024px;
  width: 100%;
  min-height: 30vh;
  max-height: 65vh;
  overflow: scroll;
}
.spacer {
  margin: auto;
}
</style>